<template>
	<v-app class="admin-v-app">
		<v-app-bar flat app class="admin-app-bar" clipped-left>
			<v-app-bar-nav-icon
				@click.stop="drawer = !drawer"
			></v-app-bar-nav-icon>

			<v-toolbar-title>CARRERAS KINESIA</v-toolbar-title>

			<v-spacer></v-spacer>
			<v-btn
				:to="{ name: 'UserMain' }"
				color="info"
				elevation="0"
				class="mx-2 rounded-lg"
				>APP</v-btn
			>
			<v-btn
				class="rounded-lg"
				outlined
				v-if="token && this.$route.path !== '/admin/login'"
				@click="logout"
				>Cerrar sesión</v-btn
			>
			<v-progress-linear
				indeterminate
				color="accent"
				absolute
				bottom
				v-if="loading"
			></v-progress-linear>
		</v-app-bar>
		<!-- mini-variant
			mini-variant-width="72" -->
		<v-navigation-drawer
			app
			floating
			clipped
			v-model="drawer"
			width="200"
			:mini-variant="miniVariant"
			:expand-on-hover="miniVariant"
		>
			<v-list nav height="100%" class="side-list" flat>
				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminStats' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-chart-line</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="nav-icon-text"
						>Estadísticas</v-list-item-title
					>
				</v-list-item>

				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminRaceList' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-run</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="nav-icon-text"
							>Carreras</v-list-item-title
						>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminCircuitList' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-selection-multiple-marker</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="nav-icon-text"
						>Circuitos</v-list-item-title
					>
				</v-list-item>

				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminUserList' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-account</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="nav-icon-text"
						>Usuarios</v-list-item-title
					>
				</v-list-item>
				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminPaymentList' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-cash</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="nav-icon-text"
						>Pagos</v-list-item-title
					>
				</v-list-item>
				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminTagList' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-tag-multiple</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="nav-icon-text"
						>Etiquetas</v-list-item-title
					>
				</v-list-item>
				<v-list-item
					class="nav-list-item"
					exact
					exact-active-class="active-link"
					:to="{ name: 'AdminResultsList' }"
				>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-map-marker-alert</v-icon>
					</v-list-item-icon>
					<v-list-item-title class="nav-icon-text"
						>Resultados</v-list-item-title
					>
				</v-list-item>
				<!-- <v-list-item link>
					<v-list-item-icon class="nav-icon">
						<v-icon>mdi-cog</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Ajustes</v-list-item-title>
				</v-list-item> -->
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<!-- Router view for the admin root view -->
			<router-view
				@snackbar-event="showSnackbar"
				@loading="showLoading"
			></router-view>

			<!-- Snackbar to show error/success messages -->
			<v-snackbar
				app
				v-model="snackbar"
				:timeout="timeout"
				:color="snackbarColor"
				class="snackbar"
				:top="$vuetify.breakpoint.mdAndDown"
			>
				<p>{{ snackbarText }}</p>

				<template v-slot:action="{ attrs }">
					<v-btn text v-bind="attrs" @click="snackbar = false"
						>Cerrar</v-btn
					>
				</template>
			</v-snackbar>
		</v-main>
	</v-app>
</template>

<script>
	import axios from "axios";
	export default {
		name: "Admin",
		data() {
			return {
				snackbarText: "",
				snackbar: false,
				timeout: 10000,
				snackbarColor: "error",
				loading: false,
				drawer: null,
			};
		},
		computed: {
			token() {
				return this.$store.getters["admin/getToken"];
			},
			miniVariant() {
				return !this.$vuetify.breakpoint.mobile;
			},
		},
		methods: {
			//We open the snackbar and set color and text
			showSnackbar(e) {
				this.snackbarText = e.text;
				this.snackbarColor = e.color;
				this.snackbar = true;
			},

			showLoading(loading) {
				if (!loading) {
					setTimeout(() => {
						this.loading = loading;
					}, 200);
				} else {
					this.loading = loading;
				}
			},
			async logout() {
				try {
					await axios.post(
						process.env.VUE_APP_BACK_URL + "/api/admin/logout",
						{
							token: this.token,
						}
					);
					this.$store.dispatch("admin/logoutSuccess");
					this.$router.push({ name: "AdminLogin" });
				} catch (error) {
					this.$emit("snackbar-event", {
						color: "error",
						text: "Ha ocurrido un error, vuelva a intentarlo más tarde",
					});
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.admin-app-bar {
		border-bottom: 1px solid rgba($color: #000000, $alpha: 0.12) !important;
	}

	.v-main {
		background-color: #f0f0f3;
	}

	.side-list {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.v-list {
		background-color: #0f0f16 !important;
		padding: 0;

		* {
			text-decoration: none;
			color: #fff !important;
		}

		.v-list-item {
			flex: none;

			&:hover {
				background-color: #191921;
			}

			.nav-icon {
				.v-icon {
					font-size: 1.75em;
				}

				margin: 0.75em 0.25em 0.75em 0.5em;
			}

			.nav-icon-text {
				margin-left: 1em;
			}
		}
	}

	.active-link {
		position: relative;
		background-color: #292931 !important;
		border-radius: 0;
		border-top-left-radius: 8px;
		border-bottom-left-radius: 8px;
		overflow: hidden;

		&::after {
			content: "";
			width: 4px;
			height: 100%;
			background-color: var(--v-accent-base);
			position: absolute;
			left: 0;
		}

		.v-icon {
			color: var(--v-accent-base) !important;
		}
	}
</style>
